import useText from '@/hooks/useText';
import { ACADEMIC_FORM_SHARED_TEXTS, ACADEMIC_FORM_CANCELLATION_TEXTS } from '../constants/academicFormTexts';

/** Hook con todos los textos del formulario de cancelación. Primera pregunta: motivo de cancelación; resto igual que renovación. */
export function useAcademicCancellationFormTexts() {
  const shared = {
    questionMainReason: useText(ACADEMIC_FORM_SHARED_TEXTS.questionMainReason),
    errorMainReason: useText(ACADEMIC_FORM_SHARED_TEXTS.errorMainReason),
    questionUsageFrequency: useText(ACADEMIC_FORM_SHARED_TEXTS.questionUsageFrequency),
    questionAccess: useText(ACADEMIC_FORM_SHARED_TEXTS.questionAccess),
    questionUsefulness: useText(ACADEMIC_FORM_SHARED_TEXTS.questionUsefulness),
    questionSuggestions: useText(ACADEMIC_FORM_SHARED_TEXTS.questionSuggestions),
    selectFrequencyPlaceholder: useText(ACADEMIC_FORM_SHARED_TEXTS.selectFrequencyPlaceholder),
    selectAccessPlaceholder: useText(ACADEMIC_FORM_SHARED_TEXTS.selectAccessPlaceholder),
    suggestionsPlaceholder: useText(ACADEMIC_FORM_SHARED_TEXTS.suggestionsPlaceholder),
    errorUsageFrequency: useText(ACADEMIC_FORM_SHARED_TEXTS.errorUsageFrequency),
    errorAccess: useText(ACADEMIC_FORM_SHARED_TEXTS.errorAccess),
    errorApplicationTypeOther: useText(ACADEMIC_FORM_SHARED_TEXTS.errorApplicationTypeOther),
    errorUsefulness: useText(ACADEMIC_FORM_SHARED_TEXTS.errorUsefulness),
    btnCancel: useText(ACADEMIC_FORM_SHARED_TEXTS.btnCancel),
    btnSubmitting: useText(ACADEMIC_FORM_SHARED_TEXTS.btnSubmitting),
    drugTarget: useText(ACADEMIC_FORM_SHARED_TEXTS.drugTarget),
    genomicVariant: useText(ACADEMIC_FORM_SHARED_TEXTS.genomicVariant),
    biomarker: useText(ACADEMIC_FORM_SHARED_TEXTS.biomarker),
    instructors: useText(ACADEMIC_FORM_SHARED_TEXTS.instructors),
    students: useText(ACADEMIC_FORM_SHARED_TEXTS.students),
    bioinformatics: useText(ACADEMIC_FORM_SHARED_TEXTS.bioinformatics),
    other: useText(ACADEMIC_FORM_SHARED_TEXTS.other),
    otherSpecifyPlaceholder: useText(ACADEMIC_FORM_SHARED_TEXTS.otherSpecifyPlaceholder),
    usefulnessNotUseful: useText(ACADEMIC_FORM_SHARED_TEXTS.usefulnessNotUseful),
    usefulnessSlightly: useText(ACADEMIC_FORM_SHARED_TEXTS.usefulnessSlightly),
    usefulnessModerately: useText(ACADEMIC_FORM_SHARED_TEXTS.usefulnessModerately),
    usefulnessVery: useText(ACADEMIC_FORM_SHARED_TEXTS.usefulnessVery),
    usefulnessExtremely: useText(ACADEMIC_FORM_SHARED_TEXTS.usefulnessExtremely),
    webInterface: useText(ACADEMIC_FORM_SHARED_TEXTS.webInterface),
    restApi: useText(ACADEMIC_FORM_SHARED_TEXTS.restApi),
    r2Package: useText(ACADEMIC_FORM_SHARED_TEXTS.r2Package),
    cytoscape: useText(ACADEMIC_FORM_SHARED_TEXTS.cytoscape),
    aida: useText(ACADEMIC_FORM_SHARED_TEXTS.aida),
    questionMarketingConsent: useText(ACADEMIC_FORM_SHARED_TEXTS.questionMarketingConsent),
    marketingConsentYes: useText(ACADEMIC_FORM_SHARED_TEXTS.marketingConsentYes),
    marketingConsentNo: useText(ACADEMIC_FORM_SHARED_TEXTS.marketingConsentNo),
    errorMarketingConsent: useText(ACADEMIC_FORM_SHARED_TEXTS.errorMarketingConsent),
  };

  const cancellation = {
    title: useText(ACADEMIC_FORM_CANCELLATION_TEXTS.title),
    description: useText(ACADEMIC_FORM_CANCELLATION_TEXTS.description),
    btnSubmit: useText(ACADEMIC_FORM_CANCELLATION_TEXTS.btnSubmit),
    mainReasonNoLongerNeed: useText(ACADEMIC_FORM_CANCELLATION_TEXTS.mainReasonNoLongerNeed),
    mainReasonDidNotUse: useText(ACADEMIC_FORM_CANCELLATION_TEXTS.mainReasonDidNotUse),
    mainReasonDataCoverage: useText(ACADEMIC_FORM_CANCELLATION_TEXTS.mainReasonDataCoverage),
    mainReasonPricing: useText(ACADEMIC_FORM_CANCELLATION_TEXTS.mainReasonPricing),
    mainReasonTechnical: useText(ACADEMIC_FORM_CANCELLATION_TEXTS.mainReasonTechnical),
    mainReasonOther: useText(ACADEMIC_FORM_CANCELLATION_TEXTS.mainReasonOther),
  };

  return {
    ...shared,
    ...cancellation,
    mainReasonOptions: [
      { value: 'no-longer-need', label: cancellation.mainReasonNoLongerNeed },
      { value: 'did-not-use-enough', label: cancellation.mainReasonDidNotUse },
      { value: 'data-coverage-issues', label: cancellation.mainReasonDataCoverage },
      { value: 'pricing-constraints', label: cancellation.mainReasonPricing },
      { value: 'technical-issues', label: cancellation.mainReasonTechnical },
      { value: 'other', label: cancellation.mainReasonOther },
    ],
    usageFrequencyOptions: [
      { value: 'drug-target', label: shared.drugTarget },
      { value: 'genomic-variant', label: shared.genomicVariant },
      { value: 'biomarker', label: shared.biomarker },
      { value: 'instructors', label: shared.instructors },
      { value: 'students', label: shared.students },
      { value: 'bioinformatics', label: shared.bioinformatics },
      { value: 'other', label: shared.other },
    ],
    accessOptions: [
      { value: 'web-interface', label: shared.webInterface },
      { value: 'rest-api', label: shared.restApi },
      { value: 'disgenet-package', label: shared.r2Package },
      { value: 'cytoscape', label: shared.cytoscape },
      { value: 'aida', label: shared.aida },
    ],
    usefulnessLabels: [
      shared.usefulnessNotUseful,
      shared.usefulnessSlightly,
      shared.usefulnessModerately,
      shared.usefulnessVery,
      shared.usefulnessExtremely,
    ],
  };
}
